import type { LocalViewId } from '@jira/polaris__domain-view/src/ViewKind.types.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { Props, State } from './NavigationView.types.tsx';
import { withRefreshBlocker } from './withRefreshBlocker.tsx';
import { findView, modifyView } from './updateContainerState.tsx';

export const deleteEmoji = (localId: LocalViewId): Action<State, Props> =>
	withRefreshBlocker(
		async (
			{ setState, getState },
			{ navigationRemote, cloudId, containerId, onSuccess, onFailure },
		) => {
			if (
				!cloudId ||
				!containerId ||
				!navigationRemote ||
				getState().containers[containerId]?.isLoading ||
				!getState().containers[containerId]?.initialized
			) {
				return;
			}

			const { view } = findView(getState().containers[containerId], localId);

			if (!view || !view.viewType) {
				return;
			}

			setState(
				modifyView(getState(), containerId, (innerView) => {
					if (innerView.localId === localId) {
						return {
							...innerView,
							emoji: undefined,
							isLocked: true,
						};
					}
					return innerView;
				}),
			);

			try {
				await navigationRemote.updateView({
					id: view.id,
					viewType: view.viewType,
					emoji: '',
				});

				setState(
					modifyView(getState(), containerId, (innerView) => {
						if (innerView.localId === localId) {
							return {
								...innerView,
								isLocked: false,
							};
						}
						return innerView;
					}),
				);

				onSuccess?.('removeEmoji');
				// oxlint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (error: any) {
				setState(
					modifyView(getState(), containerId, (innerView) => {
						if (innerView.localId === localId) {
							return {
								...innerView,
								isLocked: false,
							};
						}
						return innerView;
					}),
				);

				onFailure?.(error, 'removeEmoji');
			}
		},
	);
